import Keycloak, { KeycloakInitOptions } from 'keycloak-js';

export const keycloakClient = new Keycloak({
  url: process.env.KEYCLOAKURL || 'https://login.salamander.network',
  realm: 'apps',
  clientId: 'appcenter-frontend',
});

export const tokenRefreshedEventEmitter = new EventTarget();

export const initOptions: KeycloakInitOptions = {
  onLoad: 'check-sso',
  checkLoginIframe: false,
};
